export function analyzeChartDirection(chartList: number[] | null | undefined) {
  if (!chartList) return '';
  // Compare the first and last elements
  if (chartList[0] > chartList[chartList.length - 1]) {
    return 'positive';
  } else if (chartList[0] < chartList[chartList.length - 1]) {
    return 'negative';
  }
}
